import {
  Box as ConstellationBox,
  Button as ConstellationButton,
  Checkbox as ConstellationCheckbox,
  CurrencyField as ConstellationCurrencyField,
  DateField as ConstellationDateField,
  Dropdown as ConstellationDropdown,
  Link as ConstellationLink,
  RadioButtonGroup as ConstellationRadioButtonGroup,
  Selector as ConstellationSelector,
  SelectorItem as ConstellationSelectorItem,
  TextField as ConstellationTextField,
  Tooltip as ConstellationTooltip,
} from '@constellation/core';
import {
  withTaggingFieldChangeHandler,
  withTaggingFieldCheckBoxClickHandler,
  withTaggingFieldClickHandler,
  withTaggingFieldDropDownClickHandler,
  withTaggingFieldRadioClickHandler,
  withTaggingQuoteClickHandler,
  withTaggingTooltipClickHandler,
} from '../../../../utils/taggingHandlers/index.js';
import CustomCurrencyFieldOriginal from '../../FormFields/CustomCurrencyField/CustomCurrencyField.js';

const Tooltip = withTaggingTooltipClickHandler(ConstellationTooltip);
const Link = withTaggingFieldClickHandler(ConstellationLink);
const Button = withTaggingFieldClickHandler(ConstellationButton);
const Dropdown = withTaggingFieldDropDownClickHandler(ConstellationDropdown);
const TextField = withTaggingFieldChangeHandler(ConstellationTextField);
const CustomCurrencyField = withTaggingFieldChangeHandler(
  CustomCurrencyFieldOriginal
);
const Box = withTaggingFieldClickHandler(ConstellationBox);
const DateField = withTaggingFieldChangeHandler(ConstellationDateField);
const CurrencyField = withTaggingFieldChangeHandler(ConstellationCurrencyField);
const Selector = withTaggingFieldClickHandler(ConstellationSelector);
const SelectorItem = withTaggingFieldRadioClickHandler(
  ConstellationSelectorItem
);
const Checkbox = withTaggingFieldCheckBoxClickHandler(ConstellationCheckbox);
const RadioButtonGroup = withTaggingFieldRadioClickHandler(
  ConstellationRadioButtonGroup
);
const QuoteSummaryButtons = withTaggingQuoteClickHandler(ConstellationButton);

export {
  Box,
  Button,
  Checkbox,
  CurrencyField,
  CustomCurrencyField,
  DateField,
  Dropdown,
  Link,
  QuoteSummaryButtons,
  RadioButtonGroup,
  Selector,
  SelectorItem,
  TextField,
  Tooltip,
};
